import { useQuery } from '@tanstack/react-query';
import {
  legalDocumentDtoSchema,
  type LegalDocumentDto,
  type LegalSlug,
} from '@tg-hookah/shared';
import { api } from '@/lib/api';

export function useLegalDocument(slug: LegalSlug) {
  return useQuery({
    queryKey: ['legal', slug] as const,
    queryFn: async (): Promise<LegalDocumentDto> => {
      // Public endpoint — works even before auth, so the consent screen can
      // route the user to the document before they've accepted anything.
      const res = await api.get(`/legal/${slug}`);
      return legalDocumentDtoSchema.parse(res.data);
    },
  });
}
